module.exports = __webpack_public_path__ + "img/golden-1.b23549a5.png";